import { render, staticRenderFns } from "./DiscountOfferNew.vue?vue&type=template&id=4813c5b7"
import script from "./DiscountOfferNew.vue?vue&type=script&lang=js"
export * from "./DiscountOfferNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports